import { useEffect, useMemo, useState } from 'react';
import { Countries } from '@constants/enums';
import { useShepherdTour } from 'react-shepherd';
import useUserPreferences from '@main-hooks/useUserPreferences';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectProfileData } from '@pages/profile/store/selectors';
import { UserPreferencesKeys } from '@main-hooks/useUserPreferences/useUserPreferences.types';
import useMediaQuery from '@main-hooks/useMediaQuery';
import { steps, tourOptions } from './steps';

const useMainTour = () => {
  const [open, setOpen] = useState(false);
  const [mobileStepRemoved, setMobileStepRemoved] = useState(false);

  const matches = useMediaQuery('(min-width: 1125px)');

  const profile = useSelector(selectProfileData);

  const { t } = useTranslation();

  const countryOrigin = useMemo(
    () => profile?.company.country,
    [profile?.company.country]
  );

  const { updateOrCreateUserPreference } = useUserPreferences();

  const tour = useShepherdTour({
    tourOptions,
    steps: steps(t, countryOrigin ?? Countries.MX),
  });

  const startTour = () => {
    setOpen(false);
    tour?.start();
  };

  const onTourFinish = () => {
    updateOrCreateUserPreference(UserPreferencesKeys.TUTORIAL_COMPLETED, true);
  };

  const relaunchTutorial = () => {
    setOpen(true);
  };

  tour?.on('cancel', onTourFinish);
  tour?.on('complete', onTourFinish);

  useEffect(() => {
    if (!matches) {
      tour?.removeStep('fifth');
      setMobileStepRemoved(true);
    }

    if (matches && mobileStepRemoved) {
      const stepToAdd = steps(t, countryOrigin ?? Countries.MX).filter(
        (item) => item.id === 'fifth'
      )[0];
      tour?.addStep(stepToAdd, steps.length - 2);
    }
  }, [matches, mobileStepRemoved, countryOrigin, t, tour]);

  return {
    open,
    startTour,
    relaunchTutorial,
    setOpen,
    onTourFinish,
  };
};

export default useMainTour;
